import React, { useState } from 'react';
import styled from 'styled-components';

import PlzSVG from '../../images/plz.inline.svg';
import OtherSVG from '../../images/custom-products/solo/arkansas-state-outline-necktie.inline.svg';
import { useEffect } from 'react';

const CartItemImageContainer = styled.div`
    flex: 1;
    .svg-container {
        padding-right: 10px;

        svg {
            .st0 {
                fill: ${(props) => props.colors.primary_color};
            }
            .st1 {
                fill: ${(props) => props.colors.secondary_color};
            }
            .st2 {
                fill: ${(props) => props.colors.accent_1};
            }
        }
    }
`;

const svgs = [
    {
        slug: 'army-aviation-necktie',
        solo: <OtherSVG />,
        lifestyle: <PlzSVG />,
    },
];

function isOdd(num) {
    return num % 2;
}

const CartItemImage = ({ image, title, isProductCustom, colors }) => {
    const [itemColors, setItemColors] = useState({
        primary_color: '',
        secondary_color: '',
        accent_1: '',
    });

    useEffect(() => {
        if (colors[1]) {
            let colorArray = colors[1] && colors[1].value.split(/[:.]/);
            colorArray = colorArray.filter(
                (item, index) => isOdd(index + 1) !== 1
            );
            let newColorsObject = {};
            // TODO: Finish else/if
            colorArray.map((color, index) => {
                color = color.trim();

                if (index === 0) {
                    newColorsObject['primary_color'] = color;
                } else if (index === 1) {
                    newColorsObject['secondary_color'] = color;
                } else if (index === 2) {
                    newColorsObject['accent_1'] = color;
                }
            });
            setItemColors(newColorsObject);
        }
    }, []);
    return (
        <CartItemImageContainer colors={itemColors}>
            {isProductCustom ? (
                <div className="svg-container">{svgs[0].solo}</div>
            ) : (
                <div className="image-container">
                    <img src={image} alt={title + ` Cart Image`} />
                </div>
            )}
        </CartItemImageContainer>
    );
};

export default CartItemImage;
